import Box from '@mui/material/Box'

export default function DiscountContext({ duration, context }: any) {
	const discountPeriod = context === 'days' ? `First ${duration} days` : ''
	if (!discountPeriod) return null
	return (
		<>
			{discountPeriod && (
				<Box component="span" sx={{ fontWeight: 700 }}>
					{discountPeriod}
				</Box>
			)}
			:{' '}
		</>
	)
}
